<script>
  import { diffedJson, formatNumber } from "@/utils";
  import { onDestroy } from "svelte";
  import { fade } from "svelte/transition";
  import { asteroid, Subscriber, collections, observable } from "@/meteor.js";
  import Modal from "@/components/Modal.svelte";
    import Menu from "@/components/Menu.svelte";
  import TopMenu from './_menu.svelte'

  export let route, routes, url, currentOrder;


  const { products } = collections;
  let form = false;
  let qty = 0;
  let pct = 15;
  let showExtended = false;
  const { id } = route.params;
  let product;


  // reactives
  const obs = observable("products", id);
  $: $obs._id && (product = $obs);
  $: product && resetForm();
  $: dirty = form && JSON.stringify(form) != JSON.stringify(product);
  $: totalPriceWithPct = product && ((100 + pct) * totalPrice) / 100;
  $: totalPrice =
    product &&
    orderQuantities.reduce((sum, qty) => {
      return sum + (qty.totalPrice || 0);
    }, 0);
  $: singlePrice =
    product &&
    product.Price.length &&
    product.Price.filter(price => price.PriceQuantity == 1)[0].Price;
  $: orderQuantities =
    product &&
    (() => {
      const sortedQuantities = product.Price.sort((curr, prev) =>
        curr.Price > prev.Price ? 1 : -1
      );

      let remainingQty = qty;
      return sortedQuantities
        .map(quantity => {
          const { PriceQuantity, Price, UOM, UOMNavn, Unit } = quantity;
          const batches = Math.floor(remainingQty / PriceQuantity);
          const qtyFromBatches = batches * PriceQuantity;
          if (batches) {
            remainingQty = remainingQty - qtyFromBatches;
            quantity = {
              ...quantity,
              batches,
              qty: qtyFromBatches,
              totalPrice: Price * qtyFromBatches * ((100 + pct) / 100),
              subtractFromStock: true
            };
          }
          return quantity;
        })
        .reverse();
    })(qty);

  // reactions
  $: product && resetForm();

  // Subscribe
  const subscribe = Subscriber();
  $: subscribe.setQuery("products", { _id: id });
  $subscribe;

  // functions
  async function resetForm() {
    form = JSON.parse(JSON.stringify(product));
  }

  $: form && sortFormPrices();
  function sortFormPrices() {
    const prices = form.Price.concat().sort((lastPrice, price) =>
      price.Price < lastPrice.Price ? 1 : -1
    );
    if (JSON.stringify(prices) !== JSON.stringify(form.Price))
      setTimeout(() => {
        form.Price = prices;
        form = form;
      });
  }

  function update() {
    asteroid.call("product.update", product._id, diffedJson(form, product));
  }

  function addQty(e) {
    const value = typeof e === "object" ? e.srcElement.value : e;
    qty = parseInt(qty || 0) + parseInt(value);
  }

  function addToStock() {
    form.InStock = form.InStock + qty;
  }

  async function addToOrder() {
    const item = {
      product: id,
      productName: form.ItemText1,
      type: "generic",
      totalPrice,
      totalPriceWithPct,
      priceQuantities: JSON.parse(JSON.stringify(orderQuantities))
    };
    await asteroid.call("orders.addItem", currentOrder._id, item);
  }

  function addPrice() {
    form.Price.push({
      PriceQuantity: 1,
      Price: 1,
      UOM: "PK",
      UOMNavn: "Pakker",
      Unit: "Pakke"
    });
    form.Price = form.Price;
  }

</script>

<style>
  .btn.pill:hover {
    @apply bg-gray-500 border-transparent text-white;
  }

  .btn.pill:active {
    @apply bg-gray-600;
  }

  .btn.pill {
    padding-bottom: 4px;
    @apply w-6 h-6 px-0 py-0 bg-white rounded-full border-gray-400 text-gray-800 border font-semibold outline-none text-center inline-block;
  }

  input.btn:hover {
    @apply bg-white border-gray-400 text-gray-800 border;
  }

  .price-overview-table {
    @apply text-right m-auto;
  }
  .price-overview-table td {
    @apply px-4;
  }

  .quick-info > * {
    @apply whitespace-no-wrap;
  }
</style>

{#if product}
  <Modal bgClick={url('../')}>
    <main
      class="product relative bg-white p-10 shadow-xl sm:rounded
      w-full sm:w-3/4 md:w-2/3 my-8 mx-auto">
     
      <TopMenu {form} bind:productName={form.ItemText1}/>
      <hr class="-mx-10">
      
      <div class="flex flex-wrap mt-4">
        <input
          class="md:text-lg lg:text-2xl text-center pb-3 w-full"
          bind:value={form.ItemText1}
          placeholder="produktnavn" />

      </div>
      <div class="">
        <div class="quick-info">
          <span>
            Kode
            <input
              class="text-lg font-bold text-gray-500 w-32"
              bind:value={form.ItemNumber} />
          </span>
          <span>
            EAN
            <input
              class="text-lg font-bold text-gray-500 w-48"
              bind:value={form.EANCode} />
          </span>
          <span>
            Lager
            <input
              id="stock"
              type="number"
              bind:value={form.InStock}
              class="w-20" />
            ({formatNumber(form.InStock * singlePrice)}) kr
          </span>

        </div>
        <table class="w-full table-auto py-8 my-16">
          <thead>
            <tr class="text-right">
              <th>Antal {form.Price[0].UOMNavn}</th>
              <th>Pris</th>
              <th>Antal</th>
              <th class="w-8" />
              <th>{form.Price[0].UOMNavn}</th>
              <th>Stk pris</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {#each orderQuantities as price}
              <tr class="text-right">
                <td>{formatNumber(price.qty)}</td>
                <td>{formatNumber(price.totalPrice, 2)}</td>
                <td>{formatNumber(price.batches)}</td>
                <td />
                <td class="bg-gray-100">{formatNumber(price.PriceQuantity)}</td>
                <td class="bg-gray-100">{formatNumber(price.Price, 2)}</td>
                <td>
                  <button
                    class="btn pill"
                    value={-price.PriceQuantity}
                    on:click={addQty}>
                    -
                  </button>
                  <button
                    class="btn pill"
                    value={price.PriceQuantity}
                    on:click={addQty}>
                    +
                  </button>
                </td>
              </tr>
            {/each}
          </tbody>

        </table>

        <div class="w-full mt-4 text-center">
          Antal {form.Price[0].UOMNavn}
          <input
            type="number"
            bind:value={qty}
            class="focus text-lg w-32 text-right" />
          <input
            type="number"
            bind:value={pct}
            class="focus text-lg w-12 text-right" />
          %
          {#if qty}
            <div>
              <div class="w-full mt-4 text-center mb-6">
                <button class="btn gray outline" on:click={addToStock}>
                  Tilføj til lager
                </button>
                <button class="btn green solid" on:click={addToOrder}>
                  Tilføj til bestilling
                </button>
              </div>

              <table class="price-overview-table">
                <tr>
                  <td>Indkøbspris</td>
                  <td>{formatNumber(totalPrice, 2)} kr</td>
                  <td />
                </tr>
                <tr>
                  <td>Salgspris</td>
                  <td>{formatNumber(totalPriceWithPct, 2)} kr</td>
                  <td class="text-left">(x {pct}%)</td>
                </tr>
                <tr>
                  <td>margin</td>
                  <td>{formatNumber(totalPriceWithPct - totalPrice, 2)} kr</td>
                  <td />
                </tr>

              </table>
            </div>
          {/if}
        </div>

        <button on:click={() => (showExtended = !showExtended)} class="mt-3">
          Vis udvidet info
        </button>
        {#if showExtended}
          {#each Object.entries(form) as [key, value]}
            {#if ['string', 'number'].includes(typeof value)}
              <div class="flex flex-wrap border-gray-100 border-b">
                <strong class="inline-block w-1/3">{key}</strong>
                <textarea
                  class="w-2/3"
                  class:bg-red-100={value !== product[key]}
                  bind:value={form[key]} />
              </div>
            {/if}
          {/each}
          <div>
            <table class="w-full table-auto">
              <thead>
                <tr>
                  <th class="text-right pr-4">Kvantitet</th>
                  <th class="text-right pr-4">Pris</th>
                  <th>UOM</th>
                  <th>UOMNavn</th>
                  <th>Enhed</th>
                </tr>
              </thead>
              <tbody>
                {#each form.Price as price}
                  <tr>
                    <td class="w-1/6">
                      <input
                        class="w-full text-right"
                        type="number"
                        bind:value={price.PriceQuantity} />
                    </td>
                    <td class="w-1/6">
                      <input
                        class="w-full text-right"
                        type="number"
                        bind:value={price.Price} />
                    </td>
                    <td class="w-1/6">
                      <input
                        class="w-full"
                        type="text"
                        bind:value={price.UOM} />
                    </td>
                    <td class="w-1/6">
                      <input
                        class="w-full"
                        type="text"
                        bind:value={price.UOMNavn} />
                    </td>
                    <td class="w-1/6">
                      <input
                        class="w-full"
                        type="text"
                        bind:value={price.Unit} />
                    </td>
                  </tr>
                {/each}
              </tbody>
            </table>
            <div>
              <button class="btn outline gray" on:click={addPrice}>
                Tilføj pris
              </button>
            </div>
          </div>
        {/if}

        {#if dirty}
          <div
            class="h-12 mt-8 text-right"
            in:fade={{ duration: 100 }}
            out:fade={{ duration: 100 }}>
            <button
              class=" rounded py-2 px-4 border border-gray-500"
              on:click={resetForm}>
              Fortryd
            </button>
            <button
              class="bg-green-600 border border-green-600 rounded text-white
              py-2 px-4"
              on:click={update}>
              Gem produkt
            </button>
          </div>
        {/if}

      </div>
    </main>
  </Modal>
{/if}
